import { Money } from '@ap/interface-bspc-core';
import { SellingCostDetail } from '@ap/ap-interface-apix-hypotheken-berekening';

export class SellingCostDetailBuilder {
    private brokerAmount: Money;
    private cancelMortgageDeed: Money;
    private newEnergyLabel: Money;

    withBrokerAmount(brokerAmount: Money): this {
        this.brokerAmount = brokerAmount;
        return this;
    }

    withCancelMortgageDeed(cancelMortgageDeed: Money): this {
        this.cancelMortgageDeed = cancelMortgageDeed;
        return this;
    }

    withNewEnergyLabel(newEnergyLabel: Money): this {
        this.newEnergyLabel = newEnergyLabel;
        return this;
    }

    build(): SellingCostDetail {
        return {
            broker_amount: this.brokerAmount,
            cancel_mortgage_deed: this.cancelMortgageDeed,
            new_energy_label: this.newEnergyLabel
        } as SellingCostDetail;
    }
}

export const aSellingCostDetail = new SellingCostDetailBuilder();
